var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8119 0.454997L20.3429 1.281C16.6849 3.68033 14.8559 6.07967 14.8559 8.479C14.8559 9.69833 15.3869 10.4063 16.4489 10.603L18.9269 8.302C19.7135 8.57733 20.4215 9.08867 21.0509 9.836C21.7195 10.544 22.0539 11.4683 22.0539 12.609C22.0539 13.7497 21.6015 14.733 20.6969 15.559C19.7922 16.3457 18.5925 16.739 17.0979 16.739C15.6425 16.739 14.4232 16.2473 13.4399 15.264C12.4959 14.2413 12.0239 12.845 12.0239 11.075C12.0239 7.22033 14.6199 3.68033 19.8119 0.454997ZM8.71986 0.454997L9.25086 1.281C5.59286 3.68033 3.76386 6.07967 3.76386 8.479C3.76386 9.69833 4.29486 10.4063 5.35686 10.603L7.83486 8.302C8.62152 8.57733 9.32952 9.08867 9.95886 9.836C10.6275 10.544 10.9619 11.4683 10.9619 12.609C10.9619 13.7497 10.5095 14.733 9.60486 15.559C8.70019 16.3457 7.50052 16.739 6.00586 16.739C4.55052 16.739 3.33119 16.2473 2.34786 15.264C1.40386 14.2413 0.931856 12.845 0.931856 11.075C0.931856 7.22033 3.52786 3.68033 8.71986 0.454997Z",
    fill: "#FF6B08"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarks);
export default __webpack_public_path__ + "static/media/marks.35ca8804f82dc4106ff0d7dc90ddc131.svg";
export { ForwardRef as ReactComponent };